import ItSpendIcon from "./it-spend-icon";
export default ItSpendIcon;